{
    "equities-symbol-quick-search-fields": [
        {
            "label": "Symbol", "columnname": "symbol", "placeholder": "Symbol",
            "width": "", "datatype": "String", "isLarge": false
        },
        {
            "label": "Issue Name", "columnname": "issueName", "placeholder": "Issue Name",
            "width": "", "datatype": "String", "isLarge": true
        }
    ],
    "equities-symbol-grid-columns": [
        {
            "display": "false",
            "ui_columnname": "Row No",
            "db_columnname": "RowNo",
            "datatype": "String",
            "mappingkey": "RowNo",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Symbol",
            "db_columnname": "Symbol",
            "datatype": "String",
            "mappingkey": "symbol",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Issue Name",
            "db_columnname": "issueName",
            "datatype": "String",
            "mappingkey": "issueName",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "ListingExchange",
            "db_columnname": "listingExchange",
            "datatype": "String",
            "mappingkey": "listingExchange",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "true",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Test Issue Flag",
            "db_columnname": "testIssueFlag",
            "datatype": "String",
            "mappingkey": "testIssueFlag",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "true",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Report Date",
            "db_columnname": "reportDate",
            "datatype": "String",
            "mappingkey": "reportDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Effective Date",
            "db_columnname": "effectiveDate",
            "datatype": "String",
            "mappingkey": "effectiveDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Expiry Date",
            "db_columnname": "expiryDate",
            "datatype": "String",
            "mappingkey": "expiryDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Updated User",
            "db_columnname": "updateUser",
            "datatype": "String",
            "mappingkey": "updateUser",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        }
    ]
}